import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { HERO_IMG } from "@/data/site";

const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative h-[100svh] w-full overflow-hidden bg-black grain"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Texas Journal cover"
          className="h-full w-full object-cover object-center hero-zoom opacity-90"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-black/30" />
      </div>

      <div className="relative z-10 h-full flex flex-col justify-between px-4 md:px-8 lg:px-12 pt-24 md:pt-28 pb-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: [0.7, 0, 0.2, 1] }}
          className="flex items-center gap-4 text-white/80"
        >
          <span className="font-accent uppercase text-xs tracking-[0.3em]">
            A Texas Fashion Magazine
          </span>
          <span className="h-px w-12 bg-white/40" />
          <span className="font-accent uppercase text-xs tracking-[0.3em]">
            Est. 2026
          </span>
        </motion.div>

        <div>
          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.1, delay: 0.15, ease: [0.7, 0, 0.2, 1] }}
            data-testid="hero-title"
            className="font-serif-display text-white uppercase leading-[0.82] tracking-tighter text-[20vw] md:text-[15vw] font-light"
          >
            Texas
            <br />
            <span className="italic font-extralight">Journal</span>
          </motion.h1>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.6 }}
            className="mt-6 flex flex-col md:flex-row md:items-end md:justify-between gap-6"
          >
            <p className="max-w-md text-white/85 font-light text-base md:text-lg leading-relaxed">
              New York attitude, Texas heat. A photography-first fashion
              publication — and a curated stage for the businesses defining every
              city in the Lone Star State.
            </p>
            <a
              href="#editorial"
              data-testid="hero-scroll-cta"
              className="group flex items-center gap-3 text-white font-accent uppercase text-xs tracking-[0.25em]"
            >
              Enter the Issue
              <span className="inline-flex h-10 w-10 items-center justify-center border border-white/50 rounded-full group-hover:bg-white group-hover:text-black transition-all duration-300">
                <ArrowDown size={16} />
              </span>
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
